export const locale = {
    lang: 'es',
    data: {
        ORDER_DETAIL: {
            TITLE: 'Detalles del Pedido',
            DATE_FORMAT_WITH_HOUR: "dd/MM/yyyy 'a las' HH:mm",
            DATETIME_FORMAT: 'dd/MM/yyyy HH:mm',
            DATE_FORMAT: 'dd/MM/yyyy',
            DATE_FORMAT_DAY_MONTH: 'dd/MM',
            DATETIME_FORMAT_DAY_MONTH: 'dd/MM HH:mm',
            DATE_WITH_TIME: '{{ date }} a las {{ time }}',
            MENU: {
                NAME: 'Pedido {{ number }}',
                DETAIL: 'Detalle del Pedido',
                BACK: 'Volver',
                APPROVAL_DESCRIPTION: 'Su presupuesto está pendiente de aprobación.',
                APPROVE: 'Aprobar',
                LABORATORY: 'Laboratorio',
                RECEIVER: 'Recibido por',
                ADDRESS: 'Dirección',
                APP: 'App',
                STATUS: 'Estado',
                CUSTOMER: 'Cliente',
                CUSTOMERS: 'Clientes',
                CUSTOMER_USER: 'Dentista',
                CREATED_AT: 'Fecha de Creación',
                APPROVED_AT: 'Fecha de Aprobación',
                EXPECTED_DATE: 'Fecha Esperada',
                END_DATE: 'Fecha de Finalización',
                CREATED_BY: 'Creado por',
                PATIENT: 'Paciente',
                PATIENT_GENDER: 'Género',
                PATIENT_BIRTHDATE: 'Fecha de Nacimiento',
                RATING: 'Calificación',
                CREATE_RATING: 'Hacer Calificación',
                DELIVERY_ROUTE: 'Ruta de entrega',
            },
            DELIVERY_ROUTE: {
                FINISHED_DATE: 'Fecha de entrega',
                EXPECTED_DATE: 'Fecha prevista',
                TRACKING_NUMBER: 'Código de rastreo',
                PERIOD: 'Período',
                STATUS: 'Estado',
            },
            REMAKE: {
                ORDER: 'Pedido',
                REMAKE: 'Repetición',
                ADJUSTMENT: 'Ajuste',
                ORIGINAL_ORDER: 'Original',
                SEQUENCE: 'Secuencia',
            },
            REMAKE_TYPE: {
                REMAKE: 'Repetición',
                REMAKE_INITIAL: 'R',
                ADJUSTMENT: 'Ajuste',
                ADJUSTMENT_INITIAL: 'A',
            },
            TOOLTIP: {
                IS_DELIVERY_CONFIRMED: 'Entrega confirmada',
            },
            TABS: {
                INFORMATION: 'Información',
                FILES: 'Archivos',
                CHAT: 'Chat',
            },
            FORM: {
                FIELDS: {
                    SEARCH: 'Buscar',
                },
            },
            TOASTR: {
                ORDER_APPROVE: {
                    SUCCESS: {
                        MESSAGE: 'Pedido aprobado con éxito',
                    },
                },
            },
            MODAL: {
                ORDER_RATING: {
                    TITLE: 'Calificación del Pedido',
                },
                BUTTONS: {
                    CREATE: 'Crear',
                    SAVE: 'Guardar',
                    PRINT: 'Imprimir',
                    CANCEL: 'Cancelar',
                },
            },
        },
    },
};
